var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06334 1.00495C9.38729 0.138599 10.6127 0.138597 10.9367 1.00494L12.7306 5.80264C12.8712 6.17849 13.2228 6.43393 13.6236 6.45145L18.7409 6.67505C19.6649 6.71543 20.0436 7.88087 19.3198 8.45668L15.3113 11.6454C14.9972 11.8952 14.8629 12.3085 14.9702 12.6952L16.3388 17.6311C16.586 18.5224 15.5946 19.2427 14.8233 18.7322L10.5519 15.9053C10.2173 15.6838 9.78271 15.6838 9.44809 15.9053L5.17672 18.7322C4.40542 19.2427 3.41403 18.5224 3.66117 17.6311L5.02983 12.6952C5.13705 12.3085 5.00275 11.8952 4.68873 11.6454L0.680223 8.45668C-0.0436163 7.88087 0.335059 6.71543 1.25911 6.67505L6.37636 6.45145C6.77724 6.43393 7.12883 6.17849 7.26936 5.80264L9.06334 1.00495Z",
    fill: "#E1B328"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.230ba1cbc96f0c9c4109f8cbd9800d3d.svg";
export { ForwardRef as ReactComponent };